






























































































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { ExamineeStudentProgress } from '@/models/evalSetting/evaluator-student-progress';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import { GEnum } from '@/constants/enum.defination';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GExamDetailProgressClassTableEvalCell from '@/views/GExamDetail/GExamDetailProgressClassTableEvalCell.vue';
import GExamDetailProgressAddEvalRequestModal from '@/views/GExamDetail/GExamDetailProgressAddEvalRequestModal.vue';
import { GPageBase } from '@/mixins';
import GExamDetailProgressDeleteEvalRequestConfirmModal from '@/views/GExamDetail/GExamDetailProgressDeleteEvalRequestConfirmModal.vue';
import { EvaluatorStudentProgress } from '@/models/evalSetting/examinee-student-progress';
import { EvaluatorStudent } from '@/models/evalSetting/evaluator-student';

@Component({
  name: 'GExamDetailProgressClassTable',
  components: { GExamDetailProgressDeleteEvalRequestConfirmModal, GExamDetailProgressAddEvalRequestModal, GExamDetailProgressClassTableEvalCell },
  computed: {},
  methods: {},
})
export default class GExamDetailProgressClassTable extends Mixins(GPageBase) {
  examineeStudentColumns: any[] = [];
  currentPageNum: number = 1;
  pageSize: number = 10;
  filterProgress: number = 0;
  filterEvaluatorStudentID: number = -1;
  showAddEvalRequestModal: boolean = false;
  showDeleteEvalRequestModal: boolean = false;
  selectedExaminee: ExamineeStudentProgress = new ExamineeStudentProgress();
  isLoading: boolean = true;
  selectedEvaluator: EvaluatorStudentProgress = new EvaluatorStudentProgress();
  @Prop() isOverall: boolean;

  mounted() {
    this.examineeStudentColumns = [
      this.columnStudentNumber,
      this.columnFullName,
      this.columnIATProgress,
      this.columnSelfProgress,
      this.columnGiftProgress,
      this.columnFreeWordSkillProgress,
      ...this.columnTrendProgress,
      this.columnEvaluatorProgress,
      this.columnAddEvalRequest,
      this.columnCompletedDate,
    ];
  }

  isResponsibleSchoolClass(schoolClassID: number): boolean {
    return this.$store.state.account.isResponsibleSchoolClass(schoolClassID);
  }

  get isBeforeEnd(): boolean {
    return evalSettingModule.evalSettingDetail.isBeforeEnd;
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get columnStudentNumber() {
    return {
      title: this.$t('LOGIN_ID').toString(),
      slot: 'student_number',
      width: 100,
      align: 'center',
    };
  }
  get columnFullName() {
    return {
      title: this.$t('EXAMINEE_NAME').toString(),
      width: 120,
      align: 'center',
      slot: 'full_name',
    };
  }
  get columnIATProgress() {
    return {
      title: this.$t('PERSONALITY').toString(),
      key: 'iat_progress',
      slot: 'iat_progress',
      width: 40,
      align: 'center',
    };
  }

  get columnSelfProgress() {
    return {
      title: this.$t('SELF').toString(),
      key: 'self_progress',
      slot: 'self_progress',
      width: 40,
      align: 'center',
    };
  }

  get columnGiftProgress() {
    return {
      title: this.$t('EACH_OTHER').toString(),
      key: 'gift_progress',
      slot: 'gift_progress',
      width: 40,
      align: 'center',
    };
  }
  get columnFreeWordSkillProgress() {
    return {
      title: this.$t('STRENGTH').toString(),
      key: 'free_word_skill_progress',
      slot: 'free_word_skill_progress',
      width: 40,
      align: 'center',
    };
  }
  get columnTrendProgress() {
    if (this.isDisplayTrend) {
      return [
        {
          title: this.$t('TREND').toString(),
          key: 'trend_progress',
          slot: 'trend_progress',
          width: 40,
          align: 'center',
        },
      ];
    } else {
      return [];
    }
  }
  get columnEvaluatorProgress() {
    return {
      title: this.$t('EVALUATOR_PROGRESS').toString(),
      key: 'evaluator_progress',
      slot: 'evaluator_progress',
      align: 'center',
    };
  }
  get columnAddEvalRequest() {
    return {
      title: this.$t('EVALUATOR').toString(),
      key: 'add_eval_request',
      slot: 'add_eval_request',
      width: 70,
      align: 'center',
    };
  }
  get columnCompletedDate() {
    return {
      title: this.$t('COMPLETED_DATE').toString(),
      key: 'completed_date',
      slot: 'completed_date',
      width: 100,
      align: 'center',
    };
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic) ||
           this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademicReadOnly);
  }

  get selectedSchoolClassID(): number {
    return evalSettingDetailModule.selectedSchoolClassID;
  }

  get examineeStudentProgressesPerPage(): ExamineeStudentProgress[] {
    if (this.examineeStudentProgressesBySchoolClassID) {
      return this.examineeStudentProgressesBySchoolClassID.slice((this.currentPageNum - 1) * this.pageSize, this.currentPageNum * this.pageSize);
    }
    return [];
  }

  get examineeStudentProgressesBySchoolClassID(): ExamineeStudentProgress[] {
    let examineeStudentProgresses: ExamineeStudentProgress[];

    if (this.isOverall) {
      examineeStudentProgresses = evalSettingDetailModule.examineeStudentProgresses;
    } else {
      if (!evalSettingDetailModule.examineeStudentProgressesBySchoolClassID.has(this.selectedSchoolClassID)) {
        return [];
      } else {
        examineeStudentProgresses = evalSettingDetailModule.examineeStudentProgressesBySchoolClassID.get(this.selectedSchoolClassID);
      }
    }

    return (
      examineeStudentProgresses
        .filter((progress: ExamineeStudentProgress) => {
          if (this.filterProgress === 0) {
            return true;
          } else if (this.filterProgress === 1) {
            return progress.isStatusCompleted;
          } else {
            return !progress.isStatusCompleted;
          }
        })
        // 評価者リストによる絞り込み
        .filter((progress: ExamineeStudentProgress) => {
          let isDisplay = false;
          if (this.filterEvaluatorStudentID > -1) {
            // リストが選択されている場合は、評価者で絞り込みを行う
            progress.evaluatorStudents.forEach((evaluatorStudent: EvaluatorStudentProgress) => {
              console.log('this.filterEvaluatorStudentID:', this.filterEvaluatorStudentID);
              console.log('evaluatorStudent.evaluatorStudentID:', evaluatorStudent.evaluatorStudentID);
              if (evaluatorStudent.evaluatorStudentID === this.filterEvaluatorStudentID) {
                isDisplay = true;
              }
            });
          } else {
            // 選択されていない場合は、評価者での絞り込みは行わない
            isDisplay = true;
          }
          return isDisplay;
        })
    );
  }

  // 評価者リストデータ作成
  get evaluatorStudents(): EvaluatorStudent[] {
    const examineeStudentProgresses = Array.from(evalSettingDetailModule.examineeStudentProgressesBySchoolClassID.values()).flatMap((progresses: ExamineeStudentProgress[]) => progresses);
    const evaluatorStudents = examineeStudentProgresses.flatMap((examineeStudentProgress: ExamineeStudentProgress) => {
      return examineeStudentProgress.evaluatorStudents.map((evaluatorStudent: EvaluatorStudentProgress) => {
        return {
          studentID: evaluatorStudent.evaluatorStudentID,
          fullName: evaluatorStudent.fullName,
        } as EvaluatorStudent;
      });
    });
    const evaluatorStudentsUniqueMap = new Map(evaluatorStudents.map((evaluatorStudent: EvaluatorStudent) => [evaluatorStudent.studentID, evaluatorStudent]));
    return Array.from(evaluatorStudentsUniqueMap.values());
  }

  get requireGiftRequest(): boolean {
    return evalSettingModule.evalSettingDetail.giftRequired;
  }

  get disableButton(): boolean {
    return !this.requireGiftRequest;
  }

  handleAddEvalRequest(index: number) {
    this.showAddEvalRequestModal = true;
    this.selectedExaminee = this.examineeStudentProgressesPerPage[index];
  }

  handlePagerChange(pageNum: number) {
    this.currentPageNum = pageNum;
  }

  handleFilterProgress() {
    this.currentPageNum = 1;
  }

  handleToStudentRecord(studentID: number) {
    window.open(`/pages/student-record/${studentID}`, '_blank');
  }

  handleUpdateTable() {
    this.isLoading = false;
    this.lazyAction(() => {
      this.isLoading = true;
    });
  }

  handleDeleteEvalRequest(examineeIndex: number, evaluatorIndex: number) {
    this.selectedExaminee = this.examineeStudentProgressesPerPage[examineeIndex];
    this.selectedEvaluator = this.selectedExaminee.evaluatorStudents[evaluatorIndex];
    this.showDeleteEvalRequestModal = true;
  }

  completedClassName(row: ExamineeStudentProgress): string {
    if (row.status === GEnum.StatusProgress.Completed) {
      return 'completed-color';
    }
  }
}
